import angular from 'angular';

const kformBuilderTooltipDirective = /* @ngInject */ (
	/** @type {import('angular').translate.ITranslateService} */ $translate,
) => ({
	restrict: 'A',
	replace:  false,
	/**
	 * @param {any} scope
	 * @param {any} element
	 * @param {import('angular').IAttributes} attributes
	 */
	link(scope, element, attributes) {
		if (attributes.kformBuilderTooltip || attributes.title) {
			let tooltip = element;
			if (attributes.popoverAppend !== 'false') {
				tooltip = angular.element('<i class="fa fa-question-circle text-muted"></i>');
				element.append(' ').append(tooltip);
			}
			tooltip.popover({
				html:      true,
				trigger:   'manual',
				placement: attributes.popoverPlacement || 'right',
				content:   $translate.instant(attributes.title || attributes.kformBuilderTooltip),
			}).on('mouseenter', (/** @type {any} */ event) => {
				const $self = angular.element(event.target);
				// @ts-ignore
				$self.popover('show');
				$self.siblings('.popover').on('mouseleave', () => {
					// @ts-ignore
					$self.popover('hide');
				});
			}).on('mouseleave', (/** @type {any} */ event) => {
				const $self = angular.element(event.target);
				// eslint-disable-next-line angular/timeout-service
				setTimeout(() => {
					if (angular.element('.popover:hover').length === 0) {
						// @ts-ignore
						$self.popover('hide');
					}
				}, 100);
			});
			element.append(' ').append(tooltip);
		}
	},
});

export default kformBuilderTooltipDirective;
